import { ChangeDetectionStrategy, Component } from '@angular/core';
import {  RouterModule } from '@angular/router';

@Component({
  selector: 'app-instapay-accounts',
  imports: [RouterModule],
  templateUrl: './instapay-accounts.html',
  styleUrl: './instapay-accounts.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstapayAccounts {

}
